<template>
  <div class="kt-grid__item kt-grid__item--fluid kt-grid" id="app-loading">
    <img alt="Logo" src="/foods_logo.png" class="app__preloader--logo"/>
    <div class="kt-spinner kt-spinner--brand"></div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {},
};
</script>

<style lang="scss">
  #app-loading {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
